import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';

const SIGNAL_COLORS = { STRONG_BUY:'#00ff88', BUY:'#00cc6a', HOLD:'#ffb800', SELL:'#ff6b6b', STRONG_SELL:'#ff4d4d' };
const MARKET_FLAGS  = { india:'🇮🇳', us:'🇺🇸', crypto:'₿', global:'🌍' };

export default function DailyPicksWidget() {
  const [portfolios,  setPortfolios]  = useState([]);
  const [selectedPort,setSelectedPort]= useState(null);
  const [picks,       setPicks]       = useState([]);
  const [loading,     setLoading]     = useState(false);
  const [generating,  setGenerating]  = useState(false);
  const [date,        setDate]        = useState('');
  const [screened,    setScreened]    = useState(0);
  const [message,     setMessage]     = useState('');

  useEffect(() => { fetchPortfolios(); }, []);
  useEffect(() => { if (selectedPort) fetchPicks(selectedPort); }, [selectedPort]);

  const fetchPortfolios = async () => {
    try {
      const r = await api.get('/portfolio');
      setPortfolios(r.data);
      if (r.data.length > 0) setSelectedPort(r.data[0]);
    } catch(e) { console.error(e); }
  };

  const fetchPicks = async (portfolio) => {
    setLoading(true);
    try {
      const r = await api.get(`/daily-picks/today?market=${portfolio.market}`);
      // Filter picks for this portfolio
      const allPicks = r.data.picks || [];
      const portPicks = allPicks.filter(p => !p.portfolio_id || p.portfolio_id === portfolio.id);
      setPicks(portPicks.length > 0 ? portPicks : allPicks);
      setDate(r.data.date || '');
      setScreened(r.data.screened || 0);
      setMessage(r.data.message || '');
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  };

  const generateNow = async () => {
    setGenerating(true);
    try {
      await api.post(`/daily-picks/generate?market=${selectedPort?.market || 'india'}`);
      if (selectedPort) await fetchPicks(selectedPort);
    } catch(e) { console.error(e); }
    finally { setGenerating(false); }
  };

  const currency = selectedPort?.currency === 'INR' ? '₹' : '$';

  return (
    <div className="card" style={{ marginBottom:'20px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'14px' }}>
        <div>
          <div className="card-title">🌅 Today's AI Picks</div>
          {date && <div style={{ fontSize:'12px', color:'rgba(255,255,255,0.3)' }}>
            {date}{screened > 0 ? ` · Screened ${screened} stocks` : ''}
          </div>}
        </div>
        <div style={{ display:'flex', gap:'8px', alignItems:'center' }}>
          {portfolios.length > 1 && (
            <select value={selectedPort?.id || ''} onChange={e => setSelectedPort(portfolios.find(p => p.id === e.target.value))}
              style={{ padding:'6px 10px', borderRadius:'8px', border:'1px solid rgba(255,255,255,0.1)', background:'#1a1f2e', color:'#fff', fontSize:'12px', cursor:'pointer' }}>
              {portfolios.map(p => <option key={p.id} value={p.id}>{MARKET_FLAGS[p.market]} {p.name}</option>)}
            </select>
          )}
          <button onClick={generateNow} disabled={generating}
            style={{ padding:'7px 14px', borderRadius:'8px', border:'1px solid rgba(0,255,136,0.3)', background:'transparent', color:'#00ff88', cursor:generating?'not-allowed':'pointer', fontSize:'12px', fontWeight:'600', whiteSpace:'nowrap' }}>
            {generating ? '🤖 Generating...' : '🔄 Generate Now'}
          </button>
        </div>
      </div>

      {/* Portfolio context */}
      {selectedPort && (
        <div style={{ display:'flex', gap:'12px', marginBottom:'12px', padding:'10px 14px', background:'rgba(255,255,255,0.03)', borderRadius:'8px', fontSize:'12px' }}>
          <span style={{ color:'rgba(255,255,255,0.4)' }}>Portfolio:</span>
          <span style={{ color:'#fff', fontWeight:'600' }}>{selectedPort.name}</span>
          {selectedPort.budget_remaining > 0 && <>
            <span style={{ color:'rgba(255,255,255,0.4)' }}>·</span>
            <span style={{ color:'#00b8ff' }}>Budget left: {currency}{parseFloat(selectedPort.budget_remaining).toLocaleString()}</span>
          </>}
          {selectedPort.niches && <>
            <span style={{ color:'rgba(255,255,255,0.4)' }}>·</span>
            <span style={{ color:'#ffb800' }}>🏷️ {selectedPort.niches.split(',').slice(0,2).join(', ')}</span>
          </>}
        </div>
      )}

      {loading && <div style={{ textAlign:'center', padding:'20px', color:'rgba(255,255,255,0.3)', fontSize:'13px' }}>Loading picks...</div>}

      {!loading && picks.length === 0 && (
        <div style={{ textAlign:'center', padding:'24px' }}>
          <div style={{ color:'rgba(255,255,255,0.3)', fontSize:'13px', marginBottom:'12px' }}>
            {message || 'No picks yet today. Auto-generated at 6 AM IST.'}
          </div>
          <button onClick={generateNow} disabled={generating} className="btn btn-primary" style={{ fontSize:'13px' }}>
            {generating ? '🤖 Generating...' : '🚀 Generate Portfolio Picks Now'}
          </button>
        </div>
      )}

      {picks.length > 0 && (
        <div style={{ display:'flex', flexDirection:'column', gap:'8px' }}>
          {picks.map((p, i) => {
            const color = SIGNAL_COLORS[p.signal] || '#00ff88';
            return (
              <div key={i} style={{ display:'flex', alignItems:'center', gap:'14px', padding:'12px 14px', background:'rgba(255,255,255,0.03)', borderRadius:'10px', border:`1px solid ${color}20` }}>
                <div style={{ width:'26px', height:'26px', borderRadius:'50%', background:`${color}20`, display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'800', fontSize:'13px', color, flexShrink:0 }}>{i+1}</div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'2px' }}>
                    <span style={{ fontFamily:'Syne,sans-serif', fontWeight:'800', fontSize:'14px' }}>{p.symbol}</span>
                    <span style={{ fontSize:'11px', color:'rgba(255,255,255,0.3)' }}>{p.sector}</span>
                    {p.tech_score && <span style={{ fontSize:'10px', padding:'1px 6px', borderRadius:'10px', background:'rgba(0,184,255,0.1)', color:'#00b8ff' }}>Score: {p.tech_score}</span>}
                  </div>
                  <div style={{ fontSize:'12px', color:'rgba(255,255,255,0.5)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.reasoning}</div>
                  {p.portfolio_fit && <div style={{ fontSize:'11px', color:'#00b8ff', marginTop:'2px', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>💡 {p.portfolio_fit}</div>}
                </div>
                <div style={{ textAlign:'right', flexShrink:0 }}>
                  <div style={{ color, fontWeight:'700', fontSize:'12px' }}>{p.signal}</div>
                  <div style={{ fontSize:'11px', color:'rgba(255,255,255,0.4)' }}>{p.confidence}%</div>
                  {p.quantity_suggested > 0 && <div style={{ fontSize:'11px', color:'#ffb800' }}>{p.quantity_suggested} shares</div>}
                  {p.target_price > 0 && <div style={{ fontSize:'11px', color:'#00ff88' }}>▶ {currency}{parseFloat(p.target_price).toLocaleString()}</div>}
                </div>
              </div>
            );
          })}
          <div style={{ textAlign:'right', marginTop:'4px' }}>
            <Link to="/portfolio" style={{ fontSize:'12px', color:'rgba(255,255,255,0.3)', textDecoration:'none' }}>View full AI suggestions in Portfolio →</Link>
          </div>
        </div>
      )}
    </div>
  );
}
